/** Larguras de borda (px). Prefixo para evitar colisão com raios. */
export const borderWidth = {
  small: 1,
  medium: 2,
  large: 3
} as const;

/** Raios de canto (px). */
export const radius = {
  minimum: 4,
  small: 8,
  medium: 16,
  large: 24
} as const;
